export interface SystemTemplate {
  display_name_english: string;
  template_description: string;
  file_id: string;
  template_internal_key: string;
  production_type: string[];
  format_genre: string[];
  credit_type: string[];
  language: string[];
  territory: string[];
  broadcaster_platform: string[];
  fund_institution: string[];
  bilingual: boolean;
}

export type MetadataFilterKey =
  | 'production_type'
  | 'format_genre'
  | 'credit_type'
  | 'language'
  | 'territory'
  | 'broadcaster_platform'
  | 'fund_institution';

export type FilterKey = MetadataFilterKey | 'bilingual';
export type Filters = Record<FilterKey, string[]>;

export const metadataFilterKeys: MetadataFilterKey[] = [
  'production_type',
  'format_genre',
  'credit_type',
  'territory',
  'broadcaster_platform',
  'fund_institution',
  'language',
];

export const templateFilterKeys: FilterKey[] = [...metadataFilterKeys, 'bilingual'];

export const emptySystemTemplateFilters = (): Filters => ({
  production_type: [],
  format_genre: [],
  credit_type: [],
  language: [],
  territory: [],
  broadcaster_platform: [],
  fund_institution: [],
  bilingual: [],
});

const matchesSelectedValues = (
  template: SystemTemplate,
  key: FilterKey,
  selectedValues: string[]
): boolean => {
  if (selectedValues.length === 0) return true;
  if (key === 'bilingual') return selectedValues.includes(template.bilingual ? 'yes' : 'no');
  return selectedValues.some((selectedValue) => template[key].includes(selectedValue));
};

export function getSystemTemplateFilterOptions(
  templates: SystemTemplate[],
  key: FilterKey
): string[] {
  if (key === 'bilingual') return ['yes', 'no'];
  return Array.from(
    new Set(templates.flatMap((template) => template[key]).filter(Boolean))
  ).sort((left, right) => left.localeCompare(right));
}

export function getVisibleFilterKeys(templates: SystemTemplate[]): FilterKey[] {
  return [
    ...metadataFilterKeys.filter((key) => getSystemTemplateFilterOptions(templates, key).length > 0),
    'bilingual',
  ];
}

export function filterSystemTemplates(
  templates: SystemTemplate[],
  filters: Filters
): SystemTemplate[] {
  return templates.filter((template) =>
    templateFilterKeys.every((key) => matchesSelectedValues(template, key, filters[key]))
  );
}
